import { render, staticRenderFns } from "./MeteorIcon.vue?vue&type=template&id=56f4c364&"
import script from "./MeteorIcon.vue?vue&type=script&lang=ts&"
export * from "./MeteorIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('56f4c364', component.options)
    } else {
      api.reload('56f4c364', component.options)
    }
    module.hot.accept("./MeteorIcon.vue?vue&type=template&id=56f4c364&", function () {
      api.rerender('56f4c364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/MeteorIcon.vue"
export default component.exports